export const VAT_RATE_ITEMS = [
  { text: 'Без НДС', value: 0 },
  { text: '5%', value: 5 },
  { text: '20%', value: 20 },
]
